import { useEffect, useState } from "react";

const API = "/api";
const token = () => localStorage.getItem("token");

const vacio = {
  nombre: "", cedula: "", telefono: "", direccion: "", email: "",
  tipo_acuerdo: "dia_15", dia_pago: "", limite_credito_activo: false,
  limite_credito: "", notas: "",
};

export default function Clientes() {
  const [clientes, setClientes] = useState<any[]>([]);
  const [form, setForm] = useState<any>(vacio);
  const [editId, setEditId] = useState<number | null>(null);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [resumenes, setResumenes] = useState<any>({});
  const [filtro, setFiltro] = useState<"activos" | "inactivos" | "todos">("activos");
  const [busqueda, setBusqueda] = useState("");
  const [mostrarSugerencias, setMostrarSugerencias] = useState(false);

  const cargar = () => {
    fetch(`${API}/creditos/clientes`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json())
      .then(d => {
        if (Array.isArray(d)) {
          setClientes(d);
          fetch(`${API}/creditos/clientes/resumenes`, { headers: { Authorization: `Bearer ${token()}` } })
            .then(r => r.json())
            .then(res => setResumenes(res))
            .catch(() => {});
        }
      })
      .catch(() => {});
  };
  useEffect(() => { cargar(); }, []);

  const clientesFiltrados = clientes
    .filter(c => (filtro === "todos" ? true : filtro === "activos" ? c.activo : !c.activo))
    .filter(c => {
      if (!busqueda.trim()) return true;
      const q = busqueda.trim().toLowerCase();
      return (
        c.nombre?.toLowerCase().includes(q) ||
        c.cedula?.toLowerCase().includes(q) ||
        c.telefono?.toLowerCase().includes(q)
      );
    });

  const sugerencias = busqueda.trim()
    ? clientes
        .filter(c => c.nombre?.toLowerCase().includes(busqueda.trim().toLowerCase()))
        .slice(0, 5)
    : [];
  const cantidadInactivos = clientes.filter(c => !c.activo).length;

  const guardar = async () => {
    const payload = {
      ...form,
      dia_pago: form.tipo_acuerdo === "dia_especifico" && form.dia_pago ? Number(form.dia_pago) : null,
      limite_credito: form.limite_credito_activo && form.limite_credito ? Number(form.limite_credito) : null,
    };
    const url = editId ? `${API}/creditos/clientes/${editId}` : `${API}/creditos/clientes`;
    const method = editId ? "PUT" : "POST";
    const r = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
      body: JSON.stringify(payload),
    });
    if (r.ok) {
      setForm(vacio);
      setEditId(null);
      setMostrarForm(false);
      cargar();
    } else {
      const err = await r.json().catch(() => ({}));
      alert("Error: " + (err.detail || "no se pudo guardar"));
    }
  };

  const editar = (c: any) => {
    setForm({
      nombre: c.nombre, cedula: c.cedula || "", telefono: c.telefono || "",
      direccion: c.direccion || "", email: c.email || "",
      tipo_acuerdo: c.tipo_acuerdo, dia_pago: c.dia_pago || "",
      limite_credito_activo: c.limite_credito_activo, limite_credito: c.limite_credito || "",
      notas: c.notas || "",
    });
    setEditId(c.id);
    setMostrarForm(true);
  };

  const toggleActivo = async (id: number) => {
    await fetch(`${API}/creditos/clientes/${id}/desactivar`, {
      method: "PUT", headers: { Authorization: `Bearer ${token()}` },
    });
    cargar();
  };

  const eliminarCliente = async (c: any) => {
    const r = resumenes[c.id];
    const advertencia = r && r.cantidad_ventas_pendientes > 0
      ? `${c.nombre} tiene ${r.cantidad_ventas_pendientes} venta(s) con saldo pendiente. Si lo eliminás, se borran TODAS sus ventas y abonos, y el stock de los productos vendidos vuelve al inventario.\n\n¿Seguro que querés eliminarlo?`
      : `¿Eliminar a ${c.nombre}? Esta acción no se puede deshacer.`;
    if (!window.confirm(advertencia)) return;

    const resp = await fetch(`${API}/creditos/clientes/${c.id}`, {
      method: "DELETE", headers: { Authorization: `Bearer ${token()}` },
    });
    if (resp.ok) {
      cargar();
    } else {
      const err = await resp.json().catch(() => ({}));
      alert("Error: " + (err.detail || "no se pudo eliminar"));
    }
  };

  const label = { display: "block", fontSize: "12px", fontWeight: 700, color: "#6b7280", marginBottom: "4px" };
  const input = { width: "100%", padding: "10px 12px", borderRadius: "10px", border: "1.5px solid #e5e7eb", fontSize: "14px", fontFamily: "Nunito,sans-serif", boxSizing: "border-box" as const };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
        <h1 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "24px", fontWeight: 900, color: "#1a1a2e" }}>
          Clientes de Crédito
        </h1>
        <button
          onClick={() => { setForm(vacio); setEditId(null); setMostrarForm(!mostrarForm); }}
          style={{ background: "#0D47A1", color: "#fff", border: "none", borderRadius: "12px", padding: "10px 20px", fontWeight: 700, cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
          {mostrarForm ? "Cancelar" : "+ Nuevo Cliente"}
        </button>
      </div>

      <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
        {[
          { id: "activos", label: `Activos (${clientes.length - cantidadInactivos})` },
          { id: "inactivos", label: `Inactivos (${cantidadInactivos})` },
          { id: "todos", label: `Todos (${clientes.length})` },
        ].map(t => (
          <button key={t.id} onClick={() => setFiltro(t.id as any)}
            style={{ background: filtro === t.id ? "#0D47A1" : "#fff", color: filtro === t.id ? "#fff" : "#374151", border: "1.5px solid #e5e7eb", borderRadius: "10px", padding: "8px 16px", fontWeight: 700, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
            {t.label}
          </button>
        ))}
      </div>

      <div style={{ position: "relative", width: "100%", maxWidth: "360px", marginBottom: "20px" }}>
        <input
          type="text"
          placeholder="Buscar por nombre, cédula o teléfono..."
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
          onFocus={() => setMostrarSugerencias(true)}
          onBlur={() => setTimeout(() => setMostrarSugerencias(false), 150)}
          style={{
            width: "100%", padding: "10px 14px", borderRadius: "10px",
            border: "1.5px solid #e5e7eb", fontSize: "14px", fontFamily: "Nunito,sans-serif",
            boxSizing: "border-box",
          }}
        />
        {mostrarSugerencias && sugerencias.length > 0 && (
          <div style={{
            position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, zIndex: 10,
            background: "#fff", borderRadius: "10px", border: "1.5px solid #e5e7eb",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)", overflow: "hidden",
          }}>
            {sugerencias.map(c => (
              <div
                key={c.id}
                onMouseDown={() => { setBusqueda(c.nombre); setMostrarSugerencias(false); }}
                style={{
                  padding: "10px 14px", fontSize: "14px", fontFamily: "Nunito,sans-serif",
                  cursor: "pointer", borderBottom: "1px solid #f3f4f6",
                }}
                onMouseEnter={e => (e.currentTarget.style.background = "#F0F7FF")}
                onMouseLeave={e => (e.currentTarget.style.background = "#fff")}
              >
                <span style={{ fontWeight: 700 }}>{c.nombre}</span>
                {c.cedula && <span style={{ color: "#9ca3af", marginLeft: "8px", fontSize: "12px" }}>🪪 {c.cedula}</span>}
              </div>
            ))}
          </div>
        )}
      </div>

      {mostrarForm && (
        <div style={{ background: "#fff", borderRadius: "16px", padding: "24px", marginBottom: "24px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "16px" }}>
            <div>
              <label style={label}>Nombre completo *</label>
              <input style={input} value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} />
            </div>
            <div>
              <label style={label}>Cédula</label>
              <input style={input} value={form.cedula} onChange={e => setForm({ ...form, cedula: e.target.value })} />
            </div>
            <div>
              <label style={label}>Teléfono</label>
              <input style={input} value={form.telefono} onChange={e => setForm({ ...form, telefono: e.target.value })} />
            </div>
            <div>
              <label style={label}>Email</label>
              <input style={input} value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
            </div>
            <div style={{ gridColumn: "1 / -1" }}>
              <label style={label}>Dirección</label>
              <input style={input} value={form.direccion} onChange={e => setForm({ ...form, direccion: e.target.value })} />
            </div>

            <div>
              <label style={label}>Acuerdo de pago *</label>
              <select style={input} value={form.tipo_acuerdo} onChange={e => setForm({ ...form, tipo_acuerdo: e.target.value })}>
                <option value="dia_15">Día 15 de cada mes</option>
                <option value="dia_30">Día 30 de cada mes</option>
                <option value="dia_especifico">Día específico</option>
              </select>
            </div>
            {form.tipo_acuerdo === "dia_especifico" && (
              <div>
                <label style={label}>¿Qué día? (1-31)</label>
                <input type="number" min={1} max={31} style={input} value={form.dia_pago}
                  onChange={e => setForm({ ...form, dia_pago: e.target.value })} />
              </div>
            )}

            <div>
              <label style={label}>
                <input type="checkbox" checked={form.limite_credito_activo}
                  onChange={e => setForm({ ...form, limite_credito_activo: e.target.checked })}
                  style={{ marginRight: "6px" }} />
                Aplicar límite de crédito
              </label>
              {form.limite_credito_activo && (
                <input type="number" style={{ ...input, marginTop: "6px" }} placeholder="Monto máximo"
                  value={form.limite_credito} onChange={e => setForm({ ...form, limite_credito: e.target.value })} />
              )}
            </div>

            <div style={{ gridColumn: "1 / -1" }}>
              <label style={label}>Notas</label>
              <textarea style={{ ...input, minHeight: "60px" }} value={form.notas}
                onChange={e => setForm({ ...form, notas: e.target.value })} />
            </div>
          </div>

          <button onClick={guardar} disabled={!form.nombre}
            style={{ marginTop: "16px", background: "#1565C0", color: "#fff", border: "none", borderRadius: "12px", padding: "12px 28px", fontWeight: 800, cursor: form.nombre ? "pointer" : "not-allowed", opacity: form.nombre ? 1 : 0.5, fontFamily: "Nunito,sans-serif" }}>
            {editId ? "Guardar cambios" : "Crear cliente"}
          </button>
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        {clientesFiltrados.map(c => {
          const r = resumenes[c.id];
          const acuerdoTexto = c.tipo_acuerdo === "dia_15" ? "Día 15" : c.tipo_acuerdo === "dia_30" ? "Día 30" : `Día ${c.dia_pago}`;
          return (
            <div key={c.id} style={{ background: "#fff", borderRadius: "16px", padding: "20px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px", opacity: c.activo ? 1 : 0.55 }}>
              <div>
                <div style={{ fontWeight: 800, fontSize: "16px", marginBottom: "4px" }}>
                  {c.nombre}
                  {!c.activo && <span style={{ marginLeft: "8px", fontSize: "11px", background: "#FEF2F2", color: "#991B1B", padding: "2px 8px", borderRadius: "6px", fontWeight: 700 }}>INACTIVO</span>}
                </div>
                <div style={{ fontSize: "13px", color: "#6b7280" }}>
                  {c.cedula && `🪪 ${c.cedula}  `}{c.telefono && `📞 ${c.telefono}`}
                </div>
                <div style={{ fontSize: "12px", color: "#9ca3af", marginTop: "4px" }}>
                  Acuerdo: <strong>{acuerdoTexto}</strong>
                  {c.limite_credito_activo && `  |  Límite: ₡${c.limite_credito?.toLocaleString()}`}
                </div>
              </div>
              <div style={{ textAlign: "right" }}>
                {r && (
                  <div style={{ marginBottom: "8px" }}>
                    <div style={{ fontFamily: "Montserrat,sans-serif", fontWeight: 900, fontSize: "18px", color: r.saldo_total > 0 ? "#ef4444" : "#22c55e" }}>
                      ₡{r.saldo_total?.toLocaleString()}
                    </div>
                    {r.proxima_fecha_pago && (
                      <div style={{ fontSize: "12px", color: "#9ca3af" }}>Próximo pago: {r.proxima_fecha_pago}</div>
                    )}
                  </div>
                )}
                <div style={{ display: "flex", gap: "6px", justifyContent: "flex-end" }}>
                  <button onClick={() => editar(c)}
                    style={{ background: "#EFF6FF", color: "#1565C0", border: "none", borderRadius: "8px", padding: "6px 12px", fontWeight: 700, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
                    Editar
                  </button>
                  <button onClick={() => toggleActivo(c.id)}
                    style={{ background: c.activo ? "#FFFBEB" : "#ECFDF5", color: c.activo ? "#92400E" : "#065F46", border: "none", borderRadius: "8px", padding: "6px 12px", fontWeight: 700, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
                    {c.activo ? "Desactivar" : "Activar"}
                  </button>
                  <button onClick={() => eliminarCliente(c)}
                    style={{ background: "#FEF2F2", color: "#991B1B", border: "none", borderRadius: "8px", padding: "6px 12px", fontWeight: 700, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
                    Eliminar
                  </button>
                </div>
              </div>
            </div>
          );
        })}
        {clientesFiltrados.length === 0 && (
          <div style={{ textAlign: "center", padding: "60px", color: "#9ca3af", background: "#fff", borderRadius: "16px" }}>
            No hay clientes {filtro === "inactivos" ? "inactivos" : filtro === "activos" ? "activos" : "registrados"}
          </div>
        )}
      </div>
    </div>
  );
}
